import { render } from "./AdvisorDailySidebar.vue?vue&type=template&id=37d9b647&scoped=true"
import script from "./AdvisorDailySidebar.vue?vue&type=script&lang=js"
export * from "./AdvisorDailySidebar.vue?vue&type=script&lang=js"

import "./AdvisorDailySidebar.vue?vue&type=style&index=0&id=37d9b647&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d9b647"],['__file',"src/layouts/teacher/AdvisorDailySidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37d9b647"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37d9b647', __exports__)) {
    api.reload('37d9b647', __exports__)
  }
  
  module.hot.accept("./AdvisorDailySidebar.vue?vue&type=template&id=37d9b647&scoped=true", () => {
    api.rerender('37d9b647', render)
  })

}


export default __exports__